import React, { useEffect, useState } from 'react';
import axios from 'axios';
const CandidateNotification = () => {
  const [allNotice, setAllNotice] = useState([]);
  const fetchNoticeList = async () => {
    try {
      const url = process.env.REACT_APP_API_URL + 'notice/allnotice';
      const response = await axios.get(url);
      setAllNotice(response.data);
    } catch (error) {
      console.error('Error fetching HR list:', error);
    }
  };
  useEffect(() => {
    fetchNoticeList();
  }, []);
  const isExpired = (expiryDate) => {
    const currentDate = new Date();
    const noticeExpiryDate = new Date(expiryDate);
    return noticeExpiryDate < currentDate;
  };
  return (
    <div className="col-lg-4">
      <div className="user-profile-card">
        <h4 className="user-profile-card-title">Notifications</h4>
        <div
          className="user-notification scrollable"
        >
          {Array.isArray(allNotice) && allNotice.map((notification) => (
            <div key={notification.notice_id} className="user-notification-item">
              <a href="#">
                <div className="user-notification-icon">
                  {notification.audience === "ALL" ? <i className="far fa-briefcase" /> : <i className="far fa-envelope" />}
                </div>
                <div className="user-notification-info">
                  <p>{notification.title}</p>
                  <p>{notification.description}</p>
                  {isExpired(notification.expiry_date) ? (
                    <span className='text-danger fw-bold'>
                      <i className="fas fa-hourglass-end" /> {new Date(notification.expiry_date).toDateString()}
                    </span>
                  ) : (
                    <span>{new Date(notification.posted_on).toDateString()}</span>
                  )}
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
export default React.memo(CandidateNotification);
